import { api } from '@/lib/api/client'
import type { CommandFactory } from './types'

export const searchCommand: CommandFactory = (context) => ({
  id: 'search',
  name: 'search',
  description: 'Search through conversations',
  acceptsArgs: true,
  handler: async (args?: string) => {
    if (!args || args.trim() === '') {
      context.onDisplayMessage?.({
        role: 'command',
        content:
          'Please provide a search query. Usage: `/search <your query>`',
        timestamp: new Date(),
      })
      return
    }

    const query = args.trim()

    try {
      context.setIsSearching?.(true)
      const { data, error } = await api.api.chat.search.post({ query })

      if (error) {
        throw new Error('Search failed')
      }

      const results = data?.results || []

      if (results.length === 0) {
        context.onDisplayMessage?.({
          role: 'command',
          content: `No results found for "${query}".`,
          timestamp: new Date(),
        })
        return
      }

      // Format results as markdown
      const formattedResults = results
        .map((result: any, index: number) => {
          const timestamp = new Date(result.timestamp).toLocaleString()
          const link = `?session=${result.sessionId}&message=${result.messageId}`
          return `**${index + 1}. "${result.preview}"\n[_${timestamp}_](${link})`
        })
        .join('\n\n')

      const content = `**Search results for "${query}":**\n\n${formattedResults}`

      context.onDisplayMessage?.({
        role: 'command',
        content,
        timestamp: new Date(),
      })
    } catch (error) {
      console.error('Search error:', error)
      context.onDisplayMessage?.({
        role: 'command',
        content:
          'Sorry, search is temporarily unavailable. Please try again later.',
        timestamp: new Date(),
      })
    } finally {
      context.setIsSearching?.(false)
    }
  },
})
